import usePayrollEssentials from "hooks/usePayrollEssentials";
import { deleteMultipleRemittances, deleteRemittance, getRemittance } from "store/entities/payroll/payrollSetup/action";
import CreateRemittanceModal from "components/__new/grossPayroll/remittance/CreateRemittanceModal";
import Table from "components/__new/common/Table";
import SearchBox from "components/__new/common/SearchBox";
import { useEffect, useState, useMemo } from "react";
import DateFormat from "utils/dateFormat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import processParams from "utils/processParams";
import { useLocation } from 'react-router-dom'
import useUrlQueryParams from "hooks/useUrlQueryParams";
import useUrlNavigation from "hooks/useUrlNavigation";
import Maybe from "components/__new/common/Maybe";
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import Pagination from "components/__new/common/pagination";
import DialogBox from "utils/dialogBox";
import { TableContent } from "components/__new/common/TableContent";
import logger from "utils/logger";
import useLoginInfo from "hooks/useLoginInfo";
import DropdownNew from "utils/dropdown";
import DeleteRemittance from "components/__new/payroll/DeleteRemittance";
import ViewRemittanceDetails from "components/__new/payroll/ViewRemittanceDetails";
import useMultiSelect from "hooks/useMultiSelect";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import Filter, { ActiveFilter } from "components/__new/common/Filter";

const Remittances = () => {
    const location = useLocation();
    const {userInfo} = useLoginInfo();
    const { selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections } = useMultiSelect();
    const {dispatch, useSelector, history} = usePayrollEssentials();
    const {urlQueryParams} = useUrlQueryParams();
    const {urlQuery} = useUrlNavigation();

    const { getRemittanceData: remittanceData, getRemittanceLoading: loading, deleteRemittanceResponse, deleteMultipleRemittanceLoading: multipleDeleteLoading, deleteRemittanceLoading } = useSelector(state => state.entities.payrollSetup)
    const remittanceValid = !loading && remittanceData?.data?.length > 0;

    const [isOpenDeleteRemittance, setIsOpenDeleteRemittance] = useState(false);
    const [remittance, setRemittance] = useState({});
    const [isOpenRemittanceDetails, setIsOpenRemittanceDetails] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isRemittanceFormOpen, setIsRemittanceFormOpen] = useState(false);

    // const toggleViewModal = () => setViewOpen(!viewOpen)
    const [listParams, setListParams] = useState({ "page": 1, "limit": 10 });
    const [sortOptions, setSortOptions] = useState([
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-up" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=asc"),
            data: {sort: 'createdAt', order: 'asc'},
            active: false,
        },
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-down" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=desc"),
            data: {sort: 'createdAt', order: 'desc'},
            active: false,
        },
    ]);
    
    const paginationData = useMemo(() => {
        if (!remittanceData?.data) return {};
        
        const { data, ...paginationInfo } = remittanceData;
        return paginationInfo;
    }, [remittanceData])
    
    // const allRemittanceIDs = remittanceData?.data?.filter(item => !item?.is_default)?.map(item => item.id)

    const fetchRemittanceItems = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "sort", "string", "", "sortBy");
        params = processParams(urlQueryParams, params, "order", "string", "", "sortOrder");
        
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");
        params = processParams(urlQueryParams, params, "dateRange", "string", "", "dateRange"); 

        const sortValue = urlQueryParams["sort"];
        const orderValue = urlQueryParams["order"];
        if (sortValue && orderValue) {
            const newSortOptions = sortOptions?.map((sortOption) => {
                if (sortOption?.data?.sort === sortValue && sortOption?.data?.order === orderValue) {
                    return {...sortOption, active: true};
                }
                else {
                    return {...sortOption, active: false};
                }
            })
            setSortOptions(newSortOptions);
        }

        setListParams(params);
        dispatch(getRemittance(params))
    }

    // const toggleSingleItem = (id) => {
    //     const alreadyExists = batch?.indexOf(id) > -1
    //     if (alreadyExists) {
    //         const filtered = batch?.filter(item => item !== id)
    //         setBatch(filtered)
    //     } else {
    //         setBatch([...batch, id])
    //     }
    // }

    // const toggleEntireList = () => {
    //     if (batch.length !== allRemittanceIDs?.length) {
    //         setBatch(allRemittanceIDs)
    //     } else {
    //         setBatch([])
    //     }
    // }

    const deleteRemittanceFn = async (item) => {
        // dispatch(deleteRemittance(item.id)).then(() => {
        // fetchRemittanceItems({"page": 1, "limit": 10});
        // setIsOpenDeleteRemittance(false);
        dispatch(deleteRemittance(remittance?.id));
        // toast.success('Remittance successfully deleted');
        // const result = await DialogBox({
		// 	title: "Delete Remittance 😰",
        //     content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{truncator(item.name)}</span>? This action cannot be undone.</div>,
		// 	buttonYes: "Delete",
        //     buttonYesClass: "btn-ep-red",
		// 	buttonNo: "Cancel",
		// });
		// if (result) {
        //     dispatch(deleteRemittance(item.id)).then(() => {
        //     fetchRemittanceItems({"page": 1, "limit": 10});
        // })
        // }
    }


    const handleBulkDelete = async () => {
        const result = await DialogBox({
			title: "Delete Remittance 😰",
            content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{selections?.length} remittances</span>? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            const selectedIds = selections.map((selection) => JSON.parse(selection).id);
            // dispatch(deleteMultipleRemittances({ids: batch})).then(() => setBatch([]));
            dispatch(deleteMultipleRemittances({ids: selectedIds}));
        }
    }

    const handleToggleRemittanceForm = () => {
        if(!isRemittanceFormOpen) {
            logger("Employer-Payroll-setup-remittanceparties-create-attempt", userInfo);
        }
        // dispatch(toggleRemittanceModal());
        setIsRemittanceFormOpen(!isRemittanceFormOpen);
    }
    
    const handleEditForm = () => {
        setIsEditMode(true);
        handleToggleRemittanceForm();
    }

    useEffect(() => {
        fetchRemittanceItems()
        // eslint-disable-next-line
    }, [location])
    
    
    useEffect(() => {
        if(deleteRemittanceResponse?.id !== undefined || deleteRemittanceResponse?.count !== undefined) {
            history.push({ ...urlQueryParams, page: 1 });
            // fetchRemittanceItems();
            setIsOpenDeleteRemittance(false);
            clearSelections();
        }
        // eslint-disable-next-line
    }, [deleteRemittanceResponse])

    return (
        <div>
            {/* <ViewRemittanceModal
                isOpen={viewOpen}
                toggleFn={toggleViewModal}
                onEdit={() => {
                    setViewOpen(false);
                    setEditModalOpen(true);
                }}
                selected={selectedRemittance}
            /> */}
            
            <ViewRemittanceDetails
                isOpen={isOpenRemittanceDetails}
                setIsOpen={setIsOpenRemittanceDetails}
                remittance={remittance}
                handleEditForm={handleEditForm}
            />

            <CreateRemittanceModal 
                handleToggleRemittanceForm={handleToggleRemittanceForm}
                userInfo={userInfo}
                logger={logger}
                isRemittanceFormOpen={isRemittanceFormOpen}
                isEditMode={isEditMode}
                setIsEditMode={setIsEditMode}
                remittance={remittance}
            />
            
            <DeleteRemittance
                loading={deleteRemittanceLoading}
                isOpen={isOpenDeleteRemittance}
                setIsOpen={setIsOpenDeleteRemittance}
                onProceed={deleteRemittanceFn}
            />

            {/* <EditCustomRemittanceModal isOpen={editModalOpen} toggleModal={() => setEditModalOpen(!editModalOpen)} /> */}

            {/* <EditStatutoryRemittanceModal
                isOpen={statutoryModalOpen}
                toggleModal={() => setStatutoryModalOpen(false)}
            /> */}

            {/* {loading === true && <Spinner message="Fetching Remittances" />} */}

            {/* {urlQueryParams?.search === undefined && loading === false && remittanceData?.data && remittanceData?.data?.length === 0 &&
                <EmptyDataUI
                    subheader="Create remittance parties that fit your organization"
                    onBtnClick={handleToggleRemittanceForm}
                    btnText="+ Create Remittance Party" />
            } */}

            {/* {loading === false && (urlQueryParams?.search !== undefined || !remittanceData?.data || remittanceData?.data?.length > 0) && */}
            <>

                <div className="box !px-0 !pb-0">
                    <div className="px-6 font-medium text-xl">
                        Remittance Parties
                    </div>

                    <div className={`px-6 mt-6 xl:flex flex-wrap ${selections?.length > 1 ? "justify-start" : "justify-between"}`}>
                        <div className="flex-grow flex items-center">
                            {/* <div className="flex">
                                <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleEntireList}
                                    checked={allRemittanceIDs?.length > 0 && batch.length === allRemittanceIDs?.length}
                                />
                            </div>
                            <div className="w-10 flex justify-center items-center">
                                <IconDotH className="h-6 svg-fill-ccc" />
                            </div>
                            <Maybe condition={batch?.length > 1}>
                                <div className="flex items-center">
                                    <BulkActionHandler
                                        count={batch?.length}
                                        onCancel={() => setBatch([])}
                                        onDelete={handleBulkDelete}
                                    />
                                </div>
                            </Maybe> */}
                            <div className="flex mr-4">
                                <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleMultiSelectHeader} />
                            </div>
                            {/* <div className="w-10 flex justify-center items-center">
                                <IconDotH className="h-6 svg-fill-ccc" />
                            </div> */}
                            <Maybe condition={selections?.length > 0}>
                                <div className="flex flex-wrap items-center">
                                    <button type="button" onClick={handleBulkDelete} className="dropdown-item dropdown-item-icon text-red-500" disabled={multipleDeleteLoading}>
                                        <Maybe condition={multipleDeleteLoading === true}>
                                            <FontAwesomeIcon icon="circle-notch" spin className="text-xl" style={{margin: "auto 0.5rem auto 0"}} />
                                        </Maybe>
                                        <Maybe condition={multipleDeleteLoading === false}>
                                            <IconTrash style={{height: "1.25rem", marginRight: "0.5rem"}} />
                                        </Maybe>
                                        Delete
                                    </button>

                                    <div className="mx-2 sm:mx-6">
                                        <div className="w-0.5 h-4 bg-gray-200"></div>
                                    </div>

                                    <div className="flex space-x-4">
                                        <div className="text-[#6C757D]">
                                            {selections?.length} selected
                                        </div>
                                        <button type="button" onClick={clearSelections}>
                                            <IconsTimes className="svg-fill-red" />
                                        </button>
                                    </div>
                                </div>
                            </Maybe>
                            <Maybe condition={selections?.length === 0}>
                                <div className="w-full max-w-sm sm:mr-6">
                                    <SearchBox placeholder="Search for remittance" name="search" extraUrlParams="page=1" />
                                </div>
                            </Maybe>
                        </div>
                        <Maybe condition={selections?.length === 0}>
                            <div className="mt-2 xl:mt-0 flex flex-wrap space-x-3 sm:space-x-6">

                                    {/* <div>
                                        <Filter filters={[
                                            {
                                            title: "Status",
                                            name: "status",
                                            dataType: "select",
                                            options: [
                                                {
                                                    display: "All",
                                                    payload: "",
                                                },
                                                {
                                                    display: "Assigned",
                                                    payload: "assigned",
                                                },
                                                {
                                                    display: "Unassigned",
                                                    payload: "unassigned",
                                                },
                                            ],
                                        },
                                        ]}/>
                                    </div> */}
                                {/* <div>
                                    <SortBy options={sortOptions} title="Sort Order: " firstOption='Select' />
                                </div> */}
                                
                                <div>
                                    <Filter 
                                        filters={[
                                            {
                                                title: "Date range",
                                                name: "dateRange",
                                                dataType: "custom-timeframe",
                                                hasResetButton: true,
                                                options: [
                                                    {
                                                        display: "Today",
                                                        payload: "today",
                                                    },
                                                    {
                                                        display: "Last 7 days",
                                                        payload: "last_7_days",
                                                    },
                                                    {
                                                        display: "30 days",
                                                        payload: "30_days",
                                                    },
                                                    {
                                                        display: "1 Year",
                                                        payload: "1_year",
                                                    },
                                                ],
                                            },
                                            {
                                                title: "Custom date range",
                                                dataType: "date-range",
                                                options: {
                                                    from: {
                                                        name: "startDate",
                                                        placeholder: "Start Date",
                                                    },
                                                    to: {
                                                        name: "endDate",
                                                        placeholder: "End Date",
                                                    },
                                                },
                                            },
                                        ]}
                                    />
                                </div>
                                
                                <div className="payroll-setup-main-page-action">
                                    <button disabled={loading || multipleDeleteLoading} onClick={handleToggleRemittanceForm} className="btn btn-md btn-ep-primary">
                                        <FontAwesomeIcon icon="plus" className="mr-2" />
                                        Add New Remittance
                                    </button>
                                </div>

                            </div>
                        </Maybe>
                    </div>
                    
                    <div className="px-6">
                        <ActiveFilter 
                            filters={{
                                "Date range": "dateRange",
                                "Period start date": "startDate", 
                                "Period end date": "endDate",
                            }} 
                        />
                    </div>

                    <div className="mt-6">
                        <div>

                            <Table>
                                <Table.Head>
                                    <th style={{ paddingRight: 0, paddingLeft: "1.5rem" }}></th>
                                    <th style={{ paddingLeft: 0 }}>Remittance Name</th>
                                    <th>Date Created</th>
                                    <th></th>
                                </Table.Head>
                                <Table.Body>

                                <TableContent
                                    loading={loading || multipleDeleteLoading}
                                    loadingText={`${multipleDeleteLoading ? "Deleting Multiple Remittances" : "Fetching Remittances"}`}
                                    data={remittanceData?.data}
                                    total={remittanceData?.data?.length}
                                    colspan={24}
                                    emptyUI={<>
                                        <div className="py-20 mx-auto text-center text-base">
                                            <div className="flex justify-center">
                                                <img src={IconEmptyBox} alt="Empty" className="h-48" />
                                            </div>
                                            <div className="text-[#101828] font-medium">
                                                No Data Available
                                            </div>
                                            <div onClick={handleToggleRemittanceForm} className="mt-1 underline cursor-pointer text-[#4A5564]">
                                                Click here to create allowance
                                            </div>
                                        </div>
                                    </>}
                                />
                                    {(!loading && !multipleDeleteLoading) && remittanceData?.data?.map((item, index) => {

                                        return (
                                            <tr key={item.id}>
                                                <td style={{ paddingRight: "15px", paddingLeft: "1.5rem", width: "20px" }}>
                                                    {!item.is_default && (
                                                        // <input
                                                        //     type="checkbox"
                                                        //     className="form-checkbox w-5 h-5 multi-select"
                                                        //     onChange={() => toggleSingleItem(item.id)}
                                                        //     checked={batch?.includes(item.id)}
                                                        //     value={item.id}
                                                        // />
                                                        <input
                                                            type="checkbox"
                                                            className="form-checkbox w-5 h-5 multi-select"
                                                            onChange={getMultiSelectBody}
                                                            checked={selections?.filter((selection) => JSON.parse(selection).id === item.id).length === 1}
                                                            value={JSON.stringify(item)}
                                                        />
                                                    )}
                                                </td>
                                                <td style={{ paddingLeft: 0 }}>
                                                    <div className={item?.is_default ? "uppercase" : "capitalize"}>
                                                        {item?.name?.replaceAll("_", " ")?.toLowerCase()}
                                                    </div>
                                                </td>
                                                {/* <td>
                                                    {item.is_default ? "Statutory" : "Custom"}
                                                </td> */}
                                                <td>
                                                    <div className="lt-gray">
                                                        {DateFormat(item?.createdAt)}
                                                    </div>
                                                </td>
                                                <td>
                                                    {/* <div className="flex items-center">
                                                        {item.is_default &&
                                                            <button onClick={() => {
                                                                dispatch(selectRemittance(item));
                                                                setStatutoryModalOpen(true);
                                                                }} className="text-ep-primary-500 mr-3">
                                                                Edit
                                                            </button>
                                                        }

                                                        {!item.is_default &&
                                                            <>
                                                                <button onClick={() => {
                                                                    dispatch(selectRemittance(item));
                                                                    toggleViewModal();
                                                                }} className="text-ep-primary-500 mr-3">
                                                                    View
                                                                </button>

                                                                <button onClick={() => {
                                                                    dispatch(selectRemittance(item));
                                                                    setEditModalOpen(true);
                                                                }} className="text-ep-primary-500 mr-3">
                                                                    Edit
                                                                </button>
                                                            </>
                                                        }

                                                        <button onClick={() => item.is_default ? null : handleSingleDelete(item)} className={`${item.is_default ? "text-[#E5E7EB] cursor-not-allowed" : "text-ep-danger"}`}>
                                                            Delete
                                                        </button>
                                                    </div> */}
                                                    <DropdownNew iconClassName="rotate-90">
                                                        <></>
                                                        <div>
                                                            <div 
                                                                onClick={() => {
                                                                    setRemittance(item);
                                                                    setIsOpenRemittanceDetails(true);
                                                                }} 
                                                                className="dropdown-item"
                                                            >
                                                                View
                                                            </div>
                                                            {
                                                                !item.is_default && (
                                                                    <>
                                                                        <div 
                                                                            onClick={() => {
                                                                                setRemittance(item);
                                                                                handleEditForm();
                                                                            }} 
                                                                            className="dropdown-item"
                                                                        >
                                                                            Edit
                                                                        </div>
                                                                        <div 
                                                                            onClick={() => {
                                                                                setRemittance(item)
                                                                                setIsOpenDeleteRemittance(true)
                                                                            }} 
                                                                            className="dropdown-item text-red-500"
                                                                        >
                                                                            Delete
                                                                        </div>
                                                                    </>
                                                                )
                                                            }
                                                        </div>
                                                    </DropdownNew>
                                                </td>
                                            </tr>
                                        )}
                                    )}

                                </Table.Body>
                            </Table>

                            <Maybe condition={remittanceValid}>
                                <div className="mt-6">
                                    <Pagination data={paginationData} limit={paginationData?.limit} />
                                </div>
                            </Maybe>

                        </div>
                    </div>
                </div>

            </>
            {/* } */}
        </div>
        )
    }


export default Remittances;